import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../lib/api";
import JaceLogin from "./JaceLogin";

// Alleen coaches (admin-accounts) mogen in JACE
export default function JaceGuard({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | denied
  const [attempt, setAttempt] = useState(0);
  const loc = useLocation();
  const stateRef = useRef(state);
  stateRef.current = state;

  useEffect(() => {
    let cancelled = false;
    // Accepteer het admin-token én een member-token met admin-rol (gedeelde sessie).
    const tokens = [...new Set([
      localStorage.getItem("joh_admin_token"),
      localStorage.getItem("joh_auth_token"),
    ].filter(Boolean))];
    if (!tokens.length) { setState("denied"); return; }
    (async () => {
      // Twee rondes: een netwerkhapering mag niet meteen het loginscherm tonen.
      let definitiveReject = false;
      for (let round = 0; round < 2 && !cancelled; round++) {
        for (const t of tokens) {
          try {
            const { data } = await api.get("/auth/me", { headers: { Authorization: `Bearer ${t}` } });
            if (["admin", "owner"].includes(data?.role)) {
              localStorage.setItem("joh_admin_token", t); // één sessie voor admin + JACE
              if (!cancelled) setState("ok");
              return;
            }
            definitiveReject = true; // server antwoordde 200, maar rol is geen coach
          } catch (err) {
            // 401/403 = token definitief ongeldig; netwerk-fout (geen response) = tijdelijk
            if (err?.response?.status === 401 || err?.response?.status === 403) definitiveReject = true;
          }
        }
        if (round === 0) await new Promise((r) => setTimeout(r, 1200));
      }
      if (cancelled) return;
      // Een actieve sessie ("ok") mag bij navigeren NOOIT stukgaan op een tijdelijke
      // netwerkfout (mobiel bereik) — alleen een definitief antwoord logt uit.
      if (definitiveReject || stateRef.current !== "ok") setState("denied");
    })();
    return () => { cancelled = true; };
    // loc.pathname: her-verifieer bij elke route-wissel — React Router hergebruikt deze
    // component-instantie tussen /jace-routes, dus zonder dit blijft een oude "ok"-status
    // hangen na uitloggen (en andersom een oude "denied" na inloggen).
  }, [attempt, loc.pathname]);

  // Vers ingelogd via het formulier: de login-response bewees de coach-rol al.
  // Direct doorlaten — geen tweede netwerkronde die op mobiel kan haperen.
  const handleLoginSuccess = (user) => {
    if (["admin", "owner"].includes(user?.role)) setState("ok");
    setAttempt((a) => a + 1);
  };

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="jace-loading">
        <span className="chip text-[#A3A3A3]">JACE // LOADING…</span>
      </div>
    );
  }
  if (state === "denied") return <JaceLogin onSuccess={handleLoginSuccess} />;
  return children;
}
